/**
 * MM Revendeurs - Moon Moon Agency
 * Custom element : onglets de zone de l'annuaire des revendeurs
 */

/*********************************************************************************************
 * 🗺️ MM REVENDEURS
 */
class MMRevendeurs extends HTMLElement {
	connectedCallback() {
		this.nav = this.querySelector('[role="tablist"]');
		this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
		this.panels = Array.from(this.querySelectorAll('.mm-revendeurs__panel'));

		// Guard clause : une seule zone (pas de nav rendue), ou section vide.
		if (!this.nav || this.tabs.length === 0) return;

		/*
		 * Le Liquid rend tous les panneaux visibles : sans JS l'annuaire reste
		 * lisible en entier. C'est donc ici, et seulement une fois le module
		 * charge, qu'on bascule sur un seul panneau a la fois.
		 */
		this.nav.hidden = false;
		this._selectTab(this.tabs[0]);

		this._bindEvents();
		window.log('info', '🗺️ [REVENDEURS]', 'Connected', { zones: this.tabs.length });
	}

	_bindEvents() {
		this.nav.addEventListener('click', (e) => {
			const tab = e.target.closest('[role="tab"]');
			if (!tab) return;
			this._selectTab(tab);
		});

		/*
		 * Navigation clavier du pattern tablist (WAI-ARIA APG) : les fleches
		 * deplacent la selection, Home/Fin vont aux extremites. Tab, lui, sort
		 * de la nav vers le panneau — d'ou le `tabindex` roulant pose par
		 * `_selectTab` : un seul onglet est atteignable au Tab.
		 */
		this.nav.addEventListener('keydown', (e) => {
			const currentIndex = this.tabs.indexOf(document.activeElement);
			if (currentIndex === -1) return;

			let nextIndex = null;

			switch (e.key) {
				case 'ArrowRight':
					nextIndex = (currentIndex + 1) % this.tabs.length;
					break;
				case 'ArrowLeft':
					nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
					break;
				case 'Home':
					nextIndex = 0;
					break;
				case 'End':
					nextIndex = this.tabs.length - 1;
					break;
				default:
					return;
			}

			e.preventDefault();
			const nextTab = this.tabs[nextIndex];
			this._selectTab(nextTab);
			nextTab.focus();
		});
	}

	_selectTab(selectedTab) {
		this.tabs.forEach((tab) => {
			const isSelected = tab === selectedTab;
			tab.setAttribute('aria-selected', String(isSelected));
			// Seul l'onglet actif reste dans l'ordre de tabulation.
			tab.setAttribute('tabindex', isSelected ? '0' : '-1');

			const panel = document.getElementById(tab.getAttribute('aria-controls'));
			if (panel) panel.hidden = !isSelected;
		});
	}
}

if (!customElements.get('mm-revendeurs')) {
	customElements.define('mm-revendeurs', MMRevendeurs);
}
